import zhCn from 'element-plus/es/locale/lang/zh-cn'
import zhTw from 'element-plus/es/locale/lang/zh-tw'
import en from 'element-plus/es/locale/lang/en'
import ja from 'element-plus/es/locale/lang/ja'
import type { Language } from 'element-plus/es/locales'

export const EL_LOCALE_MAPPING: Record<string, Language> = {
    cn: zhCn,
    tw: zhTw,
    en,
    jp: ja,
}

export function getElLocale(locale: string): Language {
    return EL_LOCALE_MAPPING[locale] || en
}
